import * as React from "react";
function SvgBigArrowRight(props, svgRef) {
  return <svg viewBox="0 0 112 88" fill="none" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}><path d="M0.5 41.7901H86.5231M86.5231 41.7901L41.0465 1.36646M86.5231 41.7901L41.0465 87.2668M70.43 1.36646L110.854 41.7901L65.3771 87.2668" style={{
      stroke: "var(--svg-color, #fff)"
    }} /></svg>;
}
const ForwardRef = React.forwardRef(SvgBigArrowRight);
export default __webpack_public_path__ + "src/openspace/assets/svg/icons/big-arrow-right.svg";
export const Scaled = {
  "0.5x": __webpack_public_path__ + "src/openspace/assets/svg/icons/big-arrow-right_0.5x.svg",
  "1x": __webpack_public_path__ + "src/openspace/assets/svg/icons/big-arrow-right_1x.svg",
  "2x": __webpack_public_path__ + "src/openspace/assets/svg/icons/big-arrow-right_2x.svg",
  "3x": __webpack_public_path__ + "src/openspace/assets/svg/icons/big-arrow-right_3x.svg",
  "4x": __webpack_public_path__ + "src/openspace/assets/svg/icons/big-arrow-right_4x.svg"
};
export { ForwardRef as ReactComponent };